import { render, staticRenderFns } from "./addorg.vue?vue&type=template&id=c733228a&scoped=true&"
import script from "./addorg.vue?vue&type=script&lang=js&"
export * from "./addorg.vue?vue&type=script&lang=js&"
import style0 from "./addorg.vue?vue&type=style&index=0&id=c733228a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c733228a",
  null
  
)

export default component.exports